import React from "react"
import { BodySubtextNormal, BodyTextRegular } from "../../typography/text"
import { Checkbox, Field, Label, CheckboxProps } from "@headlessui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import { triggerPulseAnimationFromId } from "../../../util/price-util"

type Props = {
  label?: string
  innerRef?: any
  innerText?: string
  labelLink?: React.ReactNode
  description?: string
  LeftComponent?: React.ReactNode
  RightComponent?: React.ReactNode
  textSize?: "small" | "regular"
  checkboxId?: string
} & CheckboxProps

export const CheckboxField = ({
  label,
  innerRef,
  description,
  LeftComponent,
  labelLink,
  disabled,
  innerText,
  textSize = "regular",
  className,
  checkboxId,
  onChange,
  RightComponent,
  ...rest
}: Props) => {
  const TextComponent =
    textSize === "small" ? BodySubtextNormal : BodyTextRegular

  return (
    <Field
      disabled={disabled}
      className={`flex flex-row items-center cursor-pointer gap-4 ${className ? className : ""}`}
    >
      <div id={checkboxId}>
        <Checkbox
          ref={innerRef}
          onChange={(checked) => {
            onChange?.(checked)
            if (checkboxId) {
              setTimeout(() => triggerPulseAnimationFromId(checkboxId), 10)
            }
          }}
          className={`group data-[disabled]:cursor-not-allowed transition-all duration-200 flex min-h-5 min-w-5 !size-5 items-center data-[disabled]:!shadow-card data-[disabled]:bg-background-disabled cursor-pointer data-[hover]:bg-baseHover data-[checked]:data-[hover]:bg-ctaMain justify-center data-[checked]:shadow-radioOrCheckmarkChecked rounded-[4px] shadow-card bg-backgroundBranded data-[checked]:bg-ctaMain`}
          {...rest}
        >
          <div className="invisible text-white group-data-[disabled]:text-foreground-subtle group-data-[checked]:visible">
            {innerText ? innerText : <FontAwesomeIcon icon={solid("check")} />}
          </div>
        </Checkbox>
      </div>
      <Label className="flex flex-row gap-2 items-center w-full data-[disabled]:cursor-not-allowed">
        {LeftComponent && LeftComponent}
        {(label || description) && (
          <>
            <div className="flex flex-col gap-1 whitespace-pre-wrap w-fit">
              {label && (
                <TextComponent
                  className={`${disabled ? "cursor-default text-foreground-disabled" : "cursor-pointer text-foreground-base"}`}
                >
                  {label} {labelLink}
                </TextComponent>
              )}
              {description && (
                <BodySubtextNormal className="text-foreground-subtle">
                  {description} {!label && labelLink ? labelLink : ""}
                </BodySubtextNormal>
              )}
            </div>
            {RightComponent && RightComponent}
          </>
        )}
      </Label>
    </Field>
  )
}
